import { calculatePackPricing, firstValue, toNumber } from './packPricing';

export const getDispatchPricing = (item) => {
  const margin = firstValue(item.dispatch_margin_percent, 10);
  const cost = toNumber(item.source_unit_price);
  const mrp = toNumber(firstValue(item.unit_mrp, item.mrp_amount, item.mrpAmount));
  const price = cost > 0
    ? calculatePackPricing({ unitCost: cost, marginPercent: margin }).dprice
    : toNumber(firstValue(item.dprice, item.discounted_price));
  return {
    margin,
    cost,
    mrp,
    price,
    exceedsMrp: mrp > 0 && price > mrp,
    discount: mrp > 0 ? Math.max(0, ((mrp - price) / mrp) * 100) : 0,
  };
};
